import { type VariantProps, cva } from 'class-variance-authority';
import Link, { type LinkProps } from 'next/link';
import { cn } from '~/lib/utils';

export const inlineLinkVariants = cva(
  'underline focus-visible:outline-none focus-visible:ring-ring focus-visible:ring-2 focus-visible:ring-offset-1 rounded-sm',
  {
    variants: {
      variant: {
        default: 'text-primary',
        inherit: 'text-inherit',
        secondary: 'text-secondary',
        destructive: 'text-destructive',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export type InlineLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  isRawLink?: boolean;
} & LinkProps &
  VariantProps<typeof inlineLinkVariants>;

export function InlineLink({
  isRawLink,
  variant,
  className,
  ...props
}: InlineLinkProps) {
  const classes = cn(inlineLinkVariants({ variant }), className);
  if (isRawLink) {
    return <a {...props} className={classes} />;
  }
  return <Link {...props} className={classes} />;
}
